import remove from 'lodash/remove';
import api from '@/api';

export default {
  namespaced: true,

  state: {
    structures: [],
    structureTypeOptions: [],
  },

  actions: {
    // payload = { projectId, reload: false }
    // 防止重复请求 有需要更新使用refresh=true
    async GetStructures({ state, commit }, payload) {
      let projectId;
      let reload = false;
      let showLoading = true;
      if (typeof payload === 'number') {
        projectId = payload;
      } else {
        projectId = payload.projectId;
        reload = payload.reload;
        showLoading = Object.keys(payload).includes('showLoading') ? payload.showLoading : showLoading;
      }


      if (state.structures && state.structures.length && !reload) {
        return state.structures;
      }
      const { structures } = await api.structure.getStructures({
        projectId,
      }, { showLoading });
      commit('SET_STRUCTURES', structures);
      return structures;
    },
    async GetStructureTypeOptions({ commit }) {
      const { options } = await api.structure.getStructureTypeOptions();
      commit('SET_STRUCTURE_TYPE_OPTIONS', options);
      return options;
    },
    async AddStructure({ commit }, form) {
      const { structure } = await api.structure.addStructure({ ...form });
      commit('ADD_STRUCTURE', structure);
      return structure;
    },
    async UpdateStructure({ commit }, form) {
      const { structure } = await api.structure.putStructure({ ...form });
      commit('UPDATE_STRUCTURE', structure);
      return structure;
    },
    // 更新监测设备配置参数config
    async UpdateStructureGnssConfig({ commit }, gnssConfigForm) {
      const { structure } = await api.structure.patchStructureGnssConfig({ ...gnssConfigForm });
      commit('UPDATE_STRUCTURE', structure);
      return structure;
    },
    async DeleteStructure({ commit }, structure) {
      await api.structure.deleteStructure({
        projectId: structure.projectId,
        structureId: structure.id,
      });
      commit('DELETE_STRUCTURE', structure);
    },

    // 获取结构物成员
    async GetMembers(_, { projectId, structureId }) {
      const { members } = await api.structure.getMembers({
        projectId, structureId,
      });
      return members;
    },
    // 设置结构物成员
    async SetMembers(_, { projectId, structureId, memberIds }) {
      await api.structure.putMembers({
        projectId, structureId, memberIds,
      });
    },
  },
  mutations: {
    SET_STRUCTURES(state, structures) {
      state.structures = structures;
    },
    SET_STRUCTURE_TYPE_OPTIONS(state, options) {
      state.structureTypeOptions = options;
    },
    ADD_STRUCTURE(state, structure) {
      const { structures } = state;
      state.structures = [...structures, structure];
    },
    UPDATE_STRUCTURE(state, structure) {
      const { structures } = state;
      const target = structures.find(item => item.id === structure.id);

      if (target) {
        Object.assign(target, structure);
        state.structures = [...structures];
      }
    },
    DELETE_STRUCTURE(state, structure) {
      const { structures } = state;
      remove(structures, item => item.id === structure.id);
      state.structures = [...structures];
    },
  },
};
